export const animList1 = ()=>{
    let elements = document.getElementsByClassName('anim');
    let count = 0;
    let interval = setInterval(()=>{
        if(count<elements.length){
            elements[count].classList.add('anim-def');
            count++;
        } 
        else{
            clearInterval(interval);
        } 
    },100);
}
